import { apiClient } from './apiClient';
import type { Employee } from '@/types/timesheet';

export async function getAllEmployees(): Promise<Employee[]> {
  return await apiClient.get<Employee[]>('/employees');
}

export async function getEmployeeById(id: string): Promise<Employee> {
  return await apiClient.get<Employee>(`/employees/${id}`);
}
